import { GoClock } from "react-icons/go";

// ENG-2045: an Rx link from before the fix was shared by the clinic admin and
// the MD; the cleanup re-issued the MD a fresh one. This page can't tell which
// of the two opened the old link, so it gives the admin product's wording and
// points the MD to their new link.
const LinkReplaced = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen gap-4">
      <div className="flex flex-col items-center justify-center h-full gap-8">
        <GoClock
          size={160}
          className="text-white bg-blue-400 p-4 rounded-full"
        />
        <div className="text-3xl text-center font-semibold">
          Your portion is complete.
        </div>
        <div className="text-xl text-center">
          This agreement is awaiting your medical director’s signature.
        </div>
        <div className="text-lg text-center">
          If you are the medical director, check your email for your new signing link.
        </div>
      </div>
    </div>
  );
};

export default LinkReplaced;
